export default "__VITE_ASSET__BPkojvI5__ 1920w";